import { Route, Routes } from 'react-router-dom';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Cart } from '@/components/Cart';
import { CookieConsent } from '@/components/CookieConsent';
import { Home } from '@/pages/Home';
import { Shop } from '@/pages/Shop';
import { ProductDetail } from '@/pages/ProductDetail';
import { Checkout } from '@/pages/Checkout';
import { CheckoutSuccess } from '@/pages/CheckoutSuccess';
import { CheckoutCancel } from '@/pages/CheckoutCancel';
import { ContactPage } from '@/pages/info/ContactPage';
import { FaqPage } from '@/pages/info/FaqPage';
import { InfoPage } from '@/pages/info/InfoPage';
import { INFO_PAGES } from '@/lib/infoPages';

const INFO_ELEMENTS = { contact: <ContactPage />, faq: <FaqPage /> };

// The storefront (everything except /admin). Rendered by the browser app and,
// with an empty cart, by the prerender step (src/ssr/render.js).
export const StoreLayout = ({
  cart = [],
  cartOpen = false,
  ageVerified = false,
  onCartOpen,
  onCartClose,
  onAddToCart,
  onUpdateQuantity,
  onRemoveItem,
  onClearCart,
}) => {
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <>
      <Navbar cartCount={cartCount} onCartOpen={onCartOpen} />

      <Cart
        isOpen={cartOpen}
        onClose={onCartClose}
        cart={cart}
        onUpdateQuantity={onUpdateQuantity}
        onRemoveItem={onRemoveItem}
      />

      <Routes>
        <Route path="/" element={<Home onAddToCart={onAddToCart} popupEnabled={ageVerified} />} />
        <Route path="/shop" element={<Shop onAddToCart={onAddToCart} />} />
        <Route path="/category/:slug" element={<Shop onAddToCart={onAddToCart} />} />
        <Route path="/product/:id" element={<ProductDetail onAddToCart={onAddToCart} />} />
        <Route path="/checkout" element={<Checkout cart={cart} onClearCart={onClearCart} />} />
        <Route path="/checkout/success" element={<CheckoutSuccess onClearCart={onClearCart} />} />
        <Route path="/checkout/cancel" element={<CheckoutCancel />} />
        {INFO_PAGES.map(({ path, key }) => (
          <Route key={key} path={path} element={INFO_ELEMENTS[key] || <InfoPage pageKey={key} />} />
        ))}
      </Routes>

      <Footer />
      <CookieConsent enabled={ageVerified} />
    </>
  );
};
